import Styles from './SearchResults.scss';

import Template from './SearchResults.hbs';
import SearchSource from 'views/components/fullscreen/theory/searchResults/SearchSource';

var SearchResults = BaseView.extend({

    searchResultViews: [],

    initialize(options) {
        _.bindAll(this,
            'loadNewCollection');

        // set reference to Theory view
        this.theory = options.theory;

        this.setElement(Template({
            Styles
        }));
    },

    /**
     * loadNewCollection - renders the search results
     *
     * @param  {Backbone.Collection} collection Collection of search results
     */
    loadNewCollection(collection) {
        // destroy previous result views
        this.clearResults();

        // check if results are found
        if (collection.length === 0) {
            this.$('.js-no-results').show();
            this.$('.js-no-results').text(
                window.i18n.gettext('No results for') +
                ' \'' +
                this.theory.searchInput.getInput() +
                '\'.'
            );
        } else {

            // render new result view
            collection.each(function(resultModel) {

                // render for all sources in concept a result
                _.each(resultModel.get('related_sources'), function(sourceModel) {
                    var source = new SearchSource({
                        model: new Backbone.Model(sourceModel),
                        concept: resultModel.get('concept'),
                        theory: this.theory
                    });
                    this.$el.append(source.$el);
                    this.registerChildView(source);

                    // store view to attribute for later removal
                    this.searchResultViews.push(source);

                }, this);

            }, this);
        }
    },

    /**
     * clearResults - Removes all searchResult Views
     *
     */
    clearResults() {
        _.each(this.searchResultViews, function(searchResult) {
            searchResult.destroy();
        }, this);

        this.$('.js-no-results').hide();

    }
});

export default SearchResults;
